import { render } from "./Modeling.vue?vue&type=template&id=348b528c"
import script from "./Modeling.vue?vue&type=script&lang=js"
export * from "./Modeling.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__